import React, { useContext, useEffect, useState } from 'react'
import { Form } from 'react-router-dom'
import Application from "../../../StateContext/Application"
import { usePDF } from 'react-to-pdf'
import { CSVLink } from 'react-csv'
// import { Excel11, failed, PDF11, pending, success, Winnericon32 } from '../../../../../public/LoginImages/importimages'
import { apiurl } from '../../../../../path'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import iconSrc from "../../../../../public/LoginImages/Dashboard32.png"

const ECSTransferFiles = () => {

    const statecalls = useContext(Application)
    const { FetchECSFiles, FetchECSFilesForTransfer, FetchECSReport, FetchECSDashboardReport, getEcsFiles, SendFund } = statecalls;
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, SetFileName] = useState([])
    const [ecsdata, SetECSData] = useState([])
    const [isLoading, setIsLoading] = useState(false);

    const [searchFileData, SetSearchFileData] = useState('')
    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
    const [CSVDATA, SetCSVDATA] = useState([])
    const [summary, setSummary] = useState({ file: "", count: 0, amount: 0 });

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(ecsdata.length / itemsPerPage);
    const paginatedData = ecsdata.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };


    let a = localStorage.getItem("FullName")
    console.log("Token in ECS Report:", a);

    useEffect(() => {
        if (a)
            GetAllECSFiles(a);
    }, [a])

    async function GetAllECSFiles(token) {
        try {
            let data = await FetchECSFilesForTransfer(token);
            console.log("Visible ECS Files:", data);

            SetECSData(Array.isArray(data) ? data : []);
        } catch (error) {
            console.log(error);
            SetECSData([]);
        }
    }

    async function GetECSReport() {
        try {
            if (!searchFileData) {
                alert("Please Select File Name")
            } else {
                let data = await FetchECSReport(searchFileData)
                console.log("data", data);
                SetECSData(data)

                if (data && data.length > 0) {
                    const totalAmount = data.reduce((sum, item) => sum + Number(item.refund_amount || 0), 0);
                    setSummary({
                        file: searchFileData,
                        count: data.length,
                        amount: totalAmount
                    });
                } else {
                    setSummary({ file: searchFileData, count: 0, amount: 0 });
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    function onSavefile() {
        if (ecsdata.length > 0) {
            const headers = Object.keys(ecsdata[0]);
            const csvData = ecsdata.map(item => headers.map(key => item[key]));
            const finalcsv = [headers, ...csvData];
            SetCSVDATA(finalcsv);
        }
    }
    const handleSelect = (fileName) => {
        setSelectedFile(fileName);
    };
   
    const handleSendFunds = async () => {
        if (!selectedFile) {
            alert("Please select at least one file");
            return;
        }

        if (isLoading) return;

        try {
            setIsLoading(true);

            const res = await SendFund([selectedFile]);
            console.log(res);

            if (res?.message) {
                alert(res.message);
            }
            window.location.reload()

        } catch (error) {
            console.log(error);
            alert("Something went wrong");
        } finally {
            setIsLoading(false);
        }
    };
   
 return (
        <div>
            <h4 style={{fontSize:"18px", margin: '15px',fontWeight:700 }}>ECS Transfer Files</h4>

            <div style={{ padding: '2rem' }}>
             
               


                <div  style={{
        padding: "0 25px 25px 25px",
        backgroundColor: "white"
    }}>
                    <div  style={{
            backgroundColor: "#fff",
            borderRadius: "14px",
            padding: "22px 25px 28px 25px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.12)"
        }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
                                <h5 style={{ paddingTop: '10px' }}>Generated ECS Files</h5>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', paddingBottom: '10px' }}>
                                <button
                                    onClick={handleSendFunds}
                                    disabled={isLoading}
                                     style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        padding: "0 18px",
        height: "40px",
        minWidth: "158px",
        background: "linear-gradient(90deg, #3548a8, #009bd8)",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontSize: "13px",
        fontWeight: "500",
        cursor: isLoading ? "not-allowed" : "pointer"
    }}
 
                                >
                                    {/* 29-09 add the img  */}
                                     <img
  src="/ECS-Management-32.png"
  alt="Logo"
  style={{
    width: "22px",
    height: "22px",
    objectFit: "contain",
  }}
/>
                                    {isLoading ? "Processing..." : "Transfer Funds"}
                                </button>
                            </div>
                       
                        </div>
                        <div className="table-responsive" style={{ width: '96%', margin: '0 auto', }}>
                            <table   style={{
        width: "100%",
        borderCollapse: "collapse",
        backgroundColor: "#fff",
        border: "1px solid #dbe4f2",
        // borderRadius: "0px",
        overflow: "hidden",
        margin: "0"
    }} ref={targetRef}>
                                <thead  style={{
        backgroundColor: "white",
        color: "#222"
    }}>
                                    {/* Summary Header */}
                                    <tr style={{backgroundColor:"#dbe4f2", margin:'0px', paddingTop:"0px",  height:"40px"}}>
                                       <th style={{ width: "110px" }}>Select File</th>
        <th style={{ width: "70px" }}>Sr.No.</th>
        <th style={{ width: "260px" }}>File Name</th>
        <th style={{ width: "150px" }}>Total Count</th>
        <th style={{ width: "160px" }}>Total Amount</th>
        <th style={{ width: "190px" }}>Date</th>
    </tr>
                                </thead>
                                <tbody>
                                    {ecsdata && ecsdata.length > 0 ? (
paginatedData.map((e, index) => (
 
                                            // <tr key={index}>
                                            //     <td>
                                            //         {/* <input
                                            //             type="checkbox"
                                            //             checked={selectedFiles.includes(e.FileName)}
                                            //             onChange={() => handleSelect(e.FileName)}
                                            //         /> */}
                                            //         <td>
                                            //             <input
                                            //                 type="radio"
                                            //                 name="selectedFile"
                                            //                 checked={selectedFile === e.FileName}
                                            //                 onChange={() => handleSelect(e.FileName)}
                                            //             />
                                            //         </td>
                                            //     </td>
                                            //     <td>{index + 1}</td>

                                            //     <td>
                                            //         <a
                                            //             href={`${apiurl}/UploadedBillsFiles/${e.FileName}`}
                                            //             target="_blank"
                                            //             rel="noreferrer"
                                            //         >
                                            //             {e.FileName}
                                            //         </a>
                                            //     </td>

                                            //     <td>{e.Total_Bidder_Count}</td>
                                            //     <td>{e.Total_ecs_Amount}</td>

                                            //     <td>
                                            //         {e.File_Upload_Date?.split('.')[0].replace('T', ' ')}
                                            //     </td>
                                            // </tr>

                                               <tr key={index}>
    <td style={{ textAlign: "center", padding: "10px" }}>
        {/* <input
            type="radio"
            name="selectedFile"
            checked={selectedFile === e.FileName}
            onChange={() => handleSelect(e.FileName)}
        /> */}
        {/* 14-10 for select an deselect */}
      
<input
    type="radio"
    name="selectedFile"
    checked={selectedFile === e.FileName}
    onClick={() => {
        if (selectedFile === e.FileName) {
            setSelectedFile(null);
        }
    }}
    onChange={() => handleSelect(e.FileName)}
/>

    </td>
                                                <td>
    {(currentPage - 1) * itemsPerPage + index + 1}
</td>
 
                                                <td>
                                                    <a
                                                        href={`${apiurl}/UploadedBillsFiles/${e.FileName}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {e.FileName}
                                                    </a>
                                                </td>
 
                                                <td>{e.Total_Bidder_Count}</td>
                                                <td>{e.Total_ecs_Amount}</td>
 
                                                <td>
                                                    {e.File_Upload_Date?.split('.')[0].replace('T', ' ')}
                                                </td>
                                            </tr>
 
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" style={{ textAlign: 'center' ,padding:"30px"}}>
                                                No ECS files found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                {/* {summary.file && (
                                        <tr style={{ backgroundColor: "#c8e5fc", fontWeight: "600" }}>
                                            <td><a href={`${apiurl}/UploadedBillsFiles/${summary.file}`} target='_blank'>{summary.file}</a></td>
                                          
                                            <td>{summary.count}</td>
                                            <td>{summary.amount}</td>
                                        </tr>
                                    )} */}

                                {/* Detail Table Header */}
                                {/* <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
                                        <th>Sr.No.</th>
                                        <th>Unique_ID</th>
                                        <th>Account_HolderName</th>
                                        <th>Account_Number</th>
                                        <th>IFSC_CODE</th>
                                        <th>Refund_amount</th>
                                        <th>Payment_Mode</th>
                                        <th>Status</th>
                                        <th>StatusDesc</th>
                                        <th>Date</th>
                                    </tr> */}


                                {/* <tbody>
                                    {paginatedData && paginatedData.length > 0 ? (
                                        paginatedData.map((e, index) => (
                                            <tr key={index}>
                                                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                <td>{e.Unique_ID}</td>
                                                <td>{e.Account_HolderName}||{e.Bank_Account_Holder_Name}</td>
                                                <td>{e.AccNumber}</td>
                                                <td>{e.IFSC_CODE}</td>
                                                <td>{e.refund_amount}</td>
                                                <td>{e.Payment_Mode}</td>
                                                <td>{e.status}</td>
                                                <td>{e.statusDesc}</td>
                                                <td>{e.Date?.split('.')[0].replace('T', ' ')}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" style={{ textAlign: 'center' }}>No data available in table</td>
                                        </tr>
                                    )}
                                </tbody> */}
                            </table>



 <div
    style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "18px",
        padding: "0 5px",
        fontSize: "13px",
        color: "#555"
    }}
>
    {/* Showing Entries */}
    <div>
        Showing{" "}
        {ecsdata.length === 0
            ? 0
            : (currentPage - 1) * itemsPerPage + 1}
        {" "}to{" "}
        {Math.min(currentPage * itemsPerPage, ecsdata.length)}
        {" "}of {ecsdata.length} entries
    </div>
 
    {/* Pagination */}
    <div
        style={{
            display: "flex",
            alignItems: "center",
            gap: "18px"
        }}
    >
        <span
            onClick={() => currentPage > 1 && handlePageChange(currentPage - 1)}
            style={{
                cursor: currentPage > 1 ? "pointer" : "default",
                color: currentPage > 1 ? "#555" : "#aaa"
            }}
        >
            &lt; Previous
        </span>
 
        {Array.from(
            { length: totalPages },
            (_, i) => i + 1
        ).map((page) => (
            <span
                key={page}
                onClick={() => handlePageChange(page)}
                style={{
                    cursor: "pointer",
                    color: currentPage === page ? "#168bd0" : "#555",
                    fontWeight: currentPage === page ? "600" : "400"
                }}
            >
                {page}
            </span>
        ))}
 
        <span
            onClick={() =>
                currentPage < totalPages &&
                handlePageChange(currentPage + 1)
            }
            style={{
                cursor: currentPage < totalPages ? "pointer" : "default",
                color: currentPage < totalPages ? "#555" : "#aaa"
            }}
        >
            Next &gt;
        </span>
    </div>
</div>
 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default ECSTransferFiles;